import { useTranslation } from 'react-i18next';
import { InputFieldTime } from 'qampo-ui-library';
import { DateField } from '../../UI/base';
import styles from './BookingDateTimeFields.module.css';

interface BookingDateTimeFieldsProps {
  date: string;
  startTime: string;
  endTime: string;
  /** An all-day booking has no window to pick, so the time fields are not rendered. */
  isAllDay?: boolean;
  dateLabel?: string;
  dateError?: string;
  timeError?: string;
  onDateChange: (date: string) => void;
  onStartTimeChange: (startTime: string) => void;
  onEndTimeChange: (endTime: string) => void;
}

export const BookingDateTimeFields = ({
  date,
  startTime,
  endTime,
  isAllDay = false,
  dateLabel,
  dateError,
  timeError,
  onDateChange,
  onStartTimeChange,
  onEndTimeChange
}: BookingDateTimeFieldsProps) => {
  const { t } = useTranslation();

  return (
    <>
      <div className={styles.dateTimeRow}>
        <DateField
          label={dateLabel ?? t('booking-date-label')}
          required
          value={date}
          onChange={onDateChange}
          error={Boolean(dateError)}
          helperText={dateError}
        />
        {!isAllDay && (
          <div className={styles.timeFields}>
            <InputFieldTime
              label={t('booking-start-time-label')}
              width={120}
              value={startTime}
              error={Boolean(timeError)}
              onChange={(e) => onStartTimeChange(e.target.value)}
            />
            <span className={styles.timeSeparator}>&ndash;</span>
            <InputFieldTime
              label={t('booking-end-time-label')}
              width={120}
              value={endTime}
              error={Boolean(timeError)}
              onChange={(e) => onEndTimeChange(e.target.value)}
            />
          </div>
        )}
      </div>
      {!isAllDay && timeError && <span className={styles.timeError}>{timeError}</span>}
    </>
  );
};
